import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';

export function initImageGallery() {
	document.querySelectorAll('[data-image-gallery]').forEach(function (block) {
		var swiperEl = block.querySelector('.image-gallery-block__track');
		if (!swiperEl || block.querySelectorAll('.image-gallery-block__slide').length < 2) return;

		// Resolve --gs-spacing-grid-gap to pixels for Swiper's spaceBetween
		var probe = document.createElement('span');
		probe.style.cssText = 'position:fixed;visibility:hidden;width:var(--gs-spacing-grid-gap)';
		document.documentElement.appendChild(probe);
		var gap = probe.offsetWidth || 16;
		document.documentElement.removeChild(probe);

		new Swiper(swiperEl, {
			modules: [Navigation, Pagination, A11y],
			slidesPerView: 'auto',
			spaceBetween: gap,
			a11y: {
				prevSlideMessage: 'Previous',
				nextSlideMessage: 'Next',
			},
			navigation: {
				prevEl: block.querySelector('.image-gallery-block__arrow--prev'),
				nextEl: block.querySelector('.image-gallery-block__arrow--next'),
			},
			pagination: {
				el: block.querySelector('.image-gallery-block__dots'),
				clickable: true,
				renderBullet: function (index, className) {
					return '<button type="button" class="image-gallery-block__dot ' + className + '" aria-label="Image ' + (index + 1) + '"></button>';
				},
			},
		});
	});
}
